import Immutable from 'immutable';
import {
  FLAG_GETTING_GENERAL_INCOME_TYPES,
  GET_GENERAL_INCOME_TYPES,
  CLEAR_GENERAL_INCOME_TYPES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_GENERAL_INCOME_TYPES:
      return state.setIn(['all', 'loading'], payload);
    case GET_GENERAL_INCOME_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_GENERAL_INCOME_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
